export function shouldSkipPersonalSign(entSig) {
    return !!(entSig === null || entSig === void 0 ? void 0 : entSig.enable) && entSig.syncShowPerson === false;
}
